import { z } from 'zod'
import { optionalString, requiredString } from '../primitives'

// Forma REAL (shared/schemas/name.ts): { first, second?, others? }
export const NameSchema = z.object({
  first: requiredString(),
  second: optionalString(),
  others: optionalString()
})

export type Name = z.infer<typeof NameSchema>
